export default "__VITE_ASSET__jaSWrvQv__"